var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135.59399,
    height: 119.558,
    viewBox: "0 0 135.59399 119.558",
    id: "svg24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs28"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "g22",
    transform: "translate(-24,-31.67)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24,31.67)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fillOpacity: 0.8,
    fill: "#f5f5f7",
    cx: 67.796997,
    cy: 106.89,
    rx: 67.796997,
    ry: 12.668,
    id: "ellipse2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 122.034,69.674 98.109,40.229 c -1.148,-1.386 -2.826,-2.225 -4.593,-2.225 h -51.44 c -1.766,0 -3.444,0.839 -4.592,2.225 L 13.56,69.674 V 85.057 H 122.035 V 69.674 Z",
    fill: "#aeb8c2",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 101.537,86.214 80.63,61.102 C 79.629,59.895 78.123,59.235 76.582,59.235 H 31.724 c -1.54,0 -3.047,0.66 -4.048,1.867 L 6.769,86.214 v 13.792 h 94.768 z",
    fill: "url(#linearGradient-1)",
    transform: "translate(13.56)",
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.83,0 h 67.933 a 4,4 0 0 1 4,4 v 93.344 a 4,4 0 0 1 -4,4 H 33.83 a 4,4 0 0 1 -4,-4 V 4 a 4,4 0 0 1 4,-4 z",
    fill: "#f5f5f7",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.678,9.953 h 50.237 a 2,2 0 0 1 2,2 V 36.91 a 2,2 0 0 1 -2,2 H 42.678 a 2,2 0 0 1 -2,-2 V 11.953 a 2,2 0 0 1 2,-2 z m 0.262,39.814 h 49.713 a 2.262,2.262 0 1 1 0,4.524 H 42.94 a 2.262,2.262 0 0 1 0,-4.524 z m 0,11.763 h 49.713 a 2.2625,2.2625 0 1 1 0,4.525 H 42.94 a 2.2625,2.2625 0 0 1 0,-4.525 z m 78.873,43.502 c -0.775,3.071 -3.497,5.36 -6.735,5.36 H 20.515 c -3.238,0 -5.96,-2.29 -6.734,-5.36 a 7.309,7.309 0 0 1 -0.222,-1.79 V 69.675 h 26.318 c 2.907,0 5.25,2.448 5.25,5.42 v 0.04 c 0,2.971 2.37,5.37 5.277,5.37 h 34.785 c 2.907,0 5.277,-2.421 5.277,-5.393 V 75.1 c 0,-2.972 2.343,-5.426 5.25,-5.426 h 26.318 v 33.569 c 0,0.617 -0.077,1.216 -0.221,1.789 z",
    fill: "#dce0e6",
    id: "path10"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no_data.8dc12e64ad015403a54a354c9d21019c.svg";
export { ForwardRef as ReactComponent };